import { Component, OnInit, Inject } from '@angular/core';
// import { Basecomponent } from 'src/app/directives/basecomponent.directive';
// import { BaseService } from 'src/app/services/base.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { DRTOConstants } from 'src/app/utils/drtoconstants';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../providers/api.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { debounceTime } from 'rxjs/operators';
import { SharedService } from 'src/app/providers/shared.service';

@Component({
  selector: 'sm-add-free-sub',
  templateUrl: './add-free-sub.component.html',
  styleUrls: ['./add-free-sub.component.scss']
})
export class AddFreeSubComponent implements OnInit {

   
  addFreeSubscriptionForm : FormGroup;
  private apiSubscription: Subscription = new Subscription();
  constructor(public dialog: MatDialogRef<AddFreeSubComponent>, @Inject(MAT_DIALOG_DATA) public parentData: any,private _apiservice: ApiService, private router: Router, private sharedService: SharedService) { 
    this.addFreeSubscriptionForm = new FormGroup({
     
      'subsType' : new FormControl("business", [Validators.required]),
      'duration' : new FormControl(null, [Validators.required])
     
  });

  }

  ngOnInit(): void {
  

  }

  saveDiscount(){
console.log(this.addFreeSubscriptionForm.value);
console.log(this.parentData.data);

let data = {
  userHash: this.parentData.data.ownerHash,
  plan_type: this.addFreeSubscriptionForm.value.subsType === "business" ? 5 : 6,
  duration: this.addFreeSubscriptionForm.value.duration,
  userType: this.addFreeSubscriptionForm.value.subsType === "business" ? 1: 2 
}

console.log(data);

this._apiservice.addFreeSubscription(data)
this.dialog.close();
 setTimeout(() => {
   this.sharedService.sendClickEvent();
 }, 1500);

  }

  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {
    this.apiSubscription.unsubscribe();
  }

}
